import axios from 'axios';

const version = 'v1';
const basePath = 'pim';

export async function getSingle(sku, ean) {
  return axios.request({
    url: `/${version}/${basePath}/`,
    method: 'get',
    params: {
      sku,
      ean,
    },
  });
}
